import { Box as BaseBox } from '@twistopayments/design-system/components/atoms/box'
import type { IconComponent } from '@twistopayments/design-system/icons'
import * as BigSvgIcons from '@twistopayments/design-system/icons/big'
import { hiddenDown } from '@twistopayments/design-system/styles'

import type { ArticleBoxComponent } from '@twisto/api-cms'

import { Button } from '../button'
import { DynamicContent } from '../dynamic-content'

import * as styles from './box.styles'

export const Box = ({ iconName, text, cta, variant }: ArticleBoxComponent) => {
  const RenderIcon =
    iconName &&
    (BigSvgIcons[`Big${iconName}` as keyof typeof BigSvgIcons] as
      | IconComponent
      | undefined)

  return (
    <BaseBox
      css={[styles.box, variant && styles[variant]]}
      startAdornment={
        RenderIcon ? <RenderIcon css={hiddenDown('sm')} /> : <></>
      }
    >
      <div css={styles.content}>
        <DynamicContent content={text} />

        {cta?.map((button) => <Button key={button.id} {...button} />)}
      </div>
    </BaseBox>
  )
}
